import {reducerAndActionsFor} from '@symbolic/react-app/src/redux/helpers/helpers'
import Cookies from 'js-cookie';
import getCookieDomain from '../../../cookie-domain';

require('henrybuilt-js-library');

var lib = window.lib;

//TODO handle invalid username/password
var tokenFor = async ({email, password}) => {
  var tokenResponse = await lib.api.request({uri: 'auth/token', body: {email, password}});
  var token = tokenResponse.data.data.token;

  Cookies.set('x-domain-api-token', token, {domain: getCookieDomain()});

  return token;
};

//TODO handle invalid token, invalid user
var userFor = async ({token}) => {
  var userResponse = await lib.api.request({uri: 'user-for-token', body: {token}});

  return _.get(userResponse, 'data.user');
};

var clearCookies = () => {
  console.warn('*** api-token cookies cleared ***');

  Cookies.remove('x-domain-api-token', {domain: getCookieDomain()});
  Cookies.remove('x-domain-api-token', {domain: window.location.hostname});
  Cookies.remove('x-domain-api-token', {domain: `.${getCookieDomain()}`});
  Cookies.remove('api-token');
  Cookies.remove('_henrybuilt_session');
  Cookies.remove('remember_user_token');
}

var {reducer, actions} = reducerAndActionsFor('session', {
  logIn: async ({token, email, password}) => {
    var isLoggedIn = false;

    try {
      if (!token && email) await tokenFor({email, password});

      var user = await userFor({token});
    }
    catch (error) {
      clearCookies();

      console.error(error);
    }

    if (user) isLoggedIn = true;

    window.isLoggedIn = isLoggedIn; //for js-lib

    return isLoggedIn ? {isLoggedIn: true, user} : {isLoggedIn: false};
  },
  logOut: async () => {
    clearCookies();

    window.isLoggedIn = false; //for js-lib

    return {isLoggedIn: false};
  }
});

var {logIn, logOut} = actions;

export default reducer;
export {logIn, logOut};
